import { axiosInstance } from "./instance";

export const getContract = (id, brand_id) => {
  return axiosInstance.get(`/contract/${id}/${brand_id}`);
};

export const putContract = (data) => {
  return axiosInstance.post(`/contract/signing-contract-habeas-data`, data);
};

export const postAddRejectedSignature = (data) => {
  return axiosInstance.post(`/contract/add-rejected-signature`,data);
};
